<template>
	<div
			id="services-page"
			class="home"
			:class="theme">
		<nav-bar></nav-bar>
		<swiper :options="swiperOption" ref="mySwiper6">
			<swiper-slide>
				<div style="height: 100%; background-image: url('../assets/img/p1.jpg'); background-size: cover; background-repeat: no-repeat;">
					<div class="slide-center">
						<h1 class="page__title-white">{{ $t('Philosophy') }}</h1>
					</div>
				</div>
			</swiper-slide>
		</swiper>
		<div id="quote-form" class="page">
			<h1 class="page__title">{{ $t('Philosophy') }}</h1>
			<hr class="page__hr">


			{{ $t('Philosophy_text_01') }}.

			{{ $t('Philosophy_text_02') }}:


			<ul>
				<li><strong>{{ $t('Professionalism') }}</strong></li>
				<li><strong>{{ $t('Innovation') }} {{ $t('and') }} {{ $t('Technology') }}</strong>.
				{{ $t('Philosophy_text_03') }}.
				</li>

				<li><strong>{{ $t('Independence') }}</strong>.
				{{ $t('Philosophy_text_04') }}.
				</li>
				<li><strong>{{ $t('Trust') }}</strong>.</li>
				<li><strong>{{ $t('Adaptability') }}</strong>.</li>
				<li><strong>{{ $t('Commitment') }}</strong>.
				{{ $t('Philosophy_text_05') }}.
				</li>
				<li><strong>{{ $t('Quality') }}</strong>.
				{{ $t('Philosophy_text_06') }}.
				</li>
				<li><strong>{{ $t('Rigor') }}</strong>.
				{{ $t('Philosophy_text_07') }}.
				</li>
				<li><strong>{{ $t('Transparency') }} {{ $t('and') }} {{ $t('Assurance') }}</strong>.
				{{ $t('Philosophy_text_08') }}.
				</li>

				<li><strong>{{ $t('Teamwork') }}</strong>.</li>
				<li><strong>{{ $t('Professional_ethics') }}</strong>.</li>
				<li><strong>{{ $t('Experience') }} {{ $t('and') }} {{ $t('Security') }}</strong>.
				{{ $t('Philosophy_text_09') }}.



				</li>
				<li><strong>{{ $t('Confidentiality') }}</strong>.
				{{ $t('Philosophy_text_10') }}.
				</li>

				<li><strong>{{ $t('Internal_regulation') }}</strong>.
				{{ $t('Philosophy_text_11') }}.
				</li>

			</ul>


		</div>
		<logo-bar></logo-bar>
		<footer-bar></footer-bar>
	</div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Vue from 'vue'
    import { localStorageMixin } from '../mixins'
    import Message from '../components/Message.vue'
    import FooterBar from '../components/FooterBar.vue'
    import LogoBar from '../components/LogoBar.vue'
    import NavBar from '../components/NavBar.vue'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'

    export default {
        name: 'philosophy',

        mixins: [localStorageMixin],

        components: {
            Message,
            FooterBar,
            LogoBar,
            NavBar,
            swiper,
            swiperSlide
        },

        data: () => ({

            error: null,
            swiperOption: {
                spaceBetween: 30,
                centeredSlides: true,
                autoplay: 4000,
                autoplayDisableOnInteraction: false,
                effect: 'fade',
                speed: 2000
            }
        }),

        computed: {
            ...mapGetters(['user',
                'theme'])
        },

        methods: {
            ...mapActions(['LOG_IN_USER'
            ]),
            closeMessage () {
                this.error = null
            }
        },

        head: {
            title: {
                inner: 'Services'
            }
        }

    }
</script>

<style scoped>
	.swiper-container {
		height: 40vh;
		width: 100%;
	}

	.slide-img {
		width: 100%;
		height: auto;
	}
</style>


// WEBPACK FOOTER //
// Philosophy.vue?b03e9e2c